export default __webpack_public_path__ + "static/folhagem-verde-d98e4339cb6e25fe5abc2f6228534fa5.webp";